import { createSlice } from '@reduxjs/toolkit';

export const DeviceReducer = createSlice({
    name: 'device',
    initialState: {
        deviceCode: null  
    },
    reducers: {
        
        setDeviceCode: (state, action) => {
            state.deviceCode = action.payload;
        },
        
        resetDeviceCode: (state) => {
            state.deviceCode = null;
        }
    }
});